<!-- 社交通讯组件 -->
<template id="social">
    <div class="account-right-item social">
        <p class="title-info">
            至少有一种通讯类型成功通过验证，否则帐号可能会在不限定期内被回收。
        </p>
        <ul class="validate-list">
            <!-- 邮箱验证 -->
            <li class="list-item clearfix">
                <div class="col-left" :class="{ 'validate-ok': statusList[0].status }">
                    <i class="fa fa-envelope pre-icon"></i>邮箱验证
                </div>
                <div class="col-right clearfix">
                    <div class="content">
            <span v-if="statusList[0].status">
              您验证的邮箱：<span class="strong">{{
                    statusList[0].value
                }}</span>
            </span>
                        <span v-else> 未验证邮箱 </span>
                    </div>
                    <div class="operation">
                        <a
                                href="javascript:;"
                                @click="operation($event, 'email')"
                                :data-operation="statusList[0].status ? 'modify' : 'validate'"
                        >
                            {{
                                statusList[0].status ? "修改" : "开始验证"
                            }}<i class="bk-icon icon-play"></i>
                        </a>
                    </div>
                </div>
            </li>
            <!-- 手机验证 -->
            <li class="list-item clearfix">
                <div class="col-left" :class="{ 'validate-ok': statusList[1].status }">
                    <i class="fa fa-phone pre-icon"></i>手机验证
                </div>
                <div class="col-right clearfix">
                    <div class="content">
            <span v-if="statusList[1].status">
              您验证的手机：<span class="strong">{{
                    statusList[1].value
                }}</span>
            </span>
                        <span v-else> 未验证手机号 </span>
                    </div>
                    <div class="operation">
                        <a
                                href="javascript:;"
                                @click="operation($event, 'phone')"
                                :data-operation="statusList[1].status ? 'modify' : 'validate'"
                        >
                            {{
                                statusList[1].status ? "修改" : "开始验证"
                            }}<i class="bk-icon icon-play"></i>
                        </a>
                    </div>
                </div>
            </li>
            <!-- 微信验证 -->
            <li class="list-item clearfix">
                <div class="col-left" :class="{ 'validate-ok': statusList[2].status }">
                    <i class="fa fa-wechat pre-icon"></i>订阅微信通知
                </div>
                <div class="col-right clearfix">
                    <div class="content">
            <span v-if="isSubscritionPublic && isSubscritionWxchat">
              已订阅
            </span>
                        <span v-else>未订阅</span>
                    </div>
                    <div class="operation">
                        <a
                                href="javascript:;"
                                v-if="isSubscritionPublic && isSubscritionWxchat"
                                @click="unSubscription"
                        >取消订阅<i class="bk-icon icon-play"></i>
                        </a>
                        <a
                                v-else
                                href="javascript:;"
                                :data-operation="'validate'"
                                @click="subscription">
                            订阅
                            <i class="bk-icon icon-play"></i>
                        </a>
                    </div>
                </div>
            </li>
            <!-- QQ验证 -->
            <!-- <li class="list-item clearfix">
              <div class="col-left">
                <i class="icon icon-qq"></i>QQ验证
              </div>
              <div class="col-right clearfix">
                <div class="content">
                  未验证QQ
                </div>
                <div class="operation">
                  <a href="javascript:void(0);">
                    开始验证<i class="icon-play"></i>
                  </a>
                </div>
              </div>
            </li> -->
            <!-- 微博验证 -->
            <!-- <li class="list-item clearfix">
              <div class="col-left" :class="{'validate-ok': statusList[3].status}">
                <i class="fa fa-weibo pre-icon"></i>微博验证
              </div>
              <div class="col-right clearfix">
                <div class="content">
                  <span v-if="statusList[3].status">
                    您验证的新浪微博号：<span class="strong">{{ statusList[3].value }}</span>
                  </span>
                  <span v-else>
                    未验证新浪微博
                  </span>
                </div>
                <div class="operation">
                  <a href="javascript:;" @click="operation($event, 'weibo')" :data-operation="statusList[3].status ? 'modify' : 'validate'">
                    {{ statusList[3].status ? '修改' : '开始验证' }}<i class="fa fa-play-circle-o"></i>
                  </a>
                </div>
              </div>
            </li> -->
        </ul>
        <!-- 验证弹窗组件 -->
        <popup :title="popup.title" :show="popup.isShow" @close="closePopup">
            <div
                    slot="popup-body"
                    :is="currentView"
                    :current-view="currentView"
                    :modify_view="modify_view"
                    :v_type="vTypeForOtherValidate"
                    :info="statusList"
                    :finish_title="finish_title"
                    @bind_email_success="bind_email_success"
                    @next="nextStep"
                    @finish="validateFinish"
                    @getStatus="getStatus"
                    @errorResult="errorResult"
            ></div>
        </popup>
        <v-alert :options="options"></v-alert>
    </div>
</template>

<script type="text/javascript">
// -----
// 个人信息页面
// -----
import popup from "./../../popup.vue";
import bind_email from "./../../validation/email/bind_email.vue";
import modify_email from "./../../validation/email/modify_email.vue";
import modify_phone from "./../../validation/phone/modify_phone.vue";
import finish from "./../../validation/finish.vue";
import bind_wechat from "./../../validation/other/bind_wechat.vue";
import modify_third_party from "./../../validation/other/modify_third_party.vue";
import vAlert from "../../alert.vue";

export default {
    data() {
        return {
            options: {
                msgText: "",
                msgIsSuccess: true,
            },
            socialMap: this.$root.config ? this.$root.config.accountInfo.social : "",
            popup: {
                isShow: false,
                title: "",
            },
            validate: {
                status: "", //当前操作状态： validate or modify
                type: "", //当前操作类型：邮箱 or 手机号 or 微信 or 微博
                step: 0, //当前操作步骤
            },
            currentView: "", //当前view
            modify_view: "", //修改的view
            vTypeForOtherValidate: "phone", //验证微信/微博时的类型
            finish_title: "",
            statusList: [
                {
                    //邮箱验证
                    type: 0,
                    status: 0,
                    value: "",
                },
                {
                    //手机验证
                    type: 1,
                    status: 0,
                    value: "",
                },
                {
                    //微信验证
                    type: 2,
                    status: 0,
                    value: "",
                },
                {
                    //微博验证
                    type: 3,
                    status: 0,
                    value: "",
                },
                {
                    //关注蓝鲸
                    type: 4,
                    status: 0,
                    value: "",
                },
            ],
            cacheSocialStatus: null, //缓存返回的社交状态
            isSubscritionPublic: false,
            isSubscritionWxchat: false
        };
    },
    computed: {
        storeUserInfo() {
            return this.$store.state.userInfo;
        },
    },
    methods: {
        async getStatus() {
            axios.get(myUrl + 'wechat/get_subscription_status').then(res => {
                const resp = res.data
                this.statusList[2].status = 0 // 默认样式 灰色
                this.isSubscritionWxchat = false // 默认值 未订阅
                this.isSubscritionPublic = resp.result // 是否关注
                // 获取值
                if (this.isSubscritionPublic) {
                    // 获取 订阅消息状态
                    this.isSubscritionWxchat = resp.data.status
                }
                // 调整样式
                if (this.isSubscritionPublic && this.isSubscritionWxchat) {
                    // 设置 启用样式
                    this.statusList[2].status = 1
                }
            })
        },
        // 微信订阅通知
        subscription() {
            // 刷新数据
            this.getStatus();
            // 判断
            if (this.isSubscritionPublic) {
                axios.post(myUrl + "wechat/subscription_wx_notification/").then((res) => {
                    if (res.data.subscription) {
                        this.$message({
                            message: "微信通知订阅成功",
                            type: "success",
                        });
                    }
                });
            } else {
                this.popup.isShow = true;
                this.popup.title = "微信扫码关注";
                this.currentView = "bind_wechat";
            }
            // 刷新数据
            this.getStatus();
        },
        unSubscription() {
            axios.post(myUrl + "wechat/unsubscription_wx_notification/").then((res) => {
                if (res.data.subscription) {
                    this.$message({
                        message: "退订成功",
                        type: "success",
                    });
                }
            });
            // 刷新数据
            this.getStatus();
        },
        /*
         ** 跳至第三方登录
         */
        jumpToThirdParty(type) {
            if (type == "weibo") {
                console.log("跳转微博");
            }

            this.popup.isShow = false;
        },
        /*
         ** 验证项操作函数
         */
        operation(e, type) {
            let target = e.target.tagName == "A" ? e.target : e.target.parentElement,
                    opr = target.getAttribute("data-operation");

            if (type == "weibo" && opr == "validate") {
                this.jumpToThirdParty("weibo");
            } else {
                this.popup.isShow = true;
                this.validate.type = type;
                this.validate.status = opr;
                this.validate.step = 1;
            }

            switch (
                    type //根据不同的点击，给popup挂载不同的弹窗内容
                    ) {
                case "email":
                    if (opr == "validate") {
                        this.popup.title = "邮箱验证";
                        this.currentView = "bind_email";
                    } else if (opr == "modify") {
                        this.popup.title = "修改验证邮箱";
                        this.currentView = "modify_email";
                        this.modify_view = "id_validate";
                    }
                    break;
                case "phone":
                    this.popup.title = "修改手机";
                    this.currentView = "modify_phone";
                    this.modify_view = "id_validate";
                    break;
                case "wechat":
                    if (opr == "validate") {
                        this.popup.title = "微信扫码关注";
                        this.currentView = "bind_wechat";
                    } else if (opr == "modify") {
                        this.popup.title = "修改验证微信";
                        this.currentView = "modify_third_party";
                    }
                    break;
                case "weibo":
                    if (opr == "modify") {
                        this.popup.title = "修改验证微博";
                        this.currentView = "modify_third_party";
                    }
            }
        },
        /*
         ** 下一步
         */
        nextStep() {
            this.validate.step++;
            let step = this.validate.step;

            switch (this.validate.type) {
                case "email":
                    if (this.validate.status == "validate") {
                        if (step == 2) {
                            this.statusList[0].status = 1;
                            this.currentView = "finish";
                        }
                    } else {
                        if (step == 2) {
                            this.modify_view = "bind_email";
                        } else if (step == 3) {
                            this.modify_view = "finish";
                        }
                    }

                    this.finish_title = "邮箱验证成功";
                    break;
                case "phone":
                    if (step == 2) {
                        this.modify_view = "bind_phone";
                    } else if (step == 3) {
                        this.statusList[1].status = 1;
                        this.modify_view = "finish";
                    }

                    this.finish_title = "手机号验证成功";
                    break;
                case "wechat":
                    if (step == 2) {
                        this.currentView = "bind_wechat";
                    }
                    break;
                case "weibo":
                    if (step == 2) {
                        this.jumpToThirdParty("weibo");
                    }
                    break;
            }
        },
        /*
         ** 完成验证
         */
        validateFinish() {
            this.popup.isShow = false;

            switch (this.validate.type) {
                case "email":
                    this.statusList[0].status = 1;
                    break;
                case "phone":
                    this.statusList[1].status = 1;
                    break;
                case "wechat":
                    this.statusList[2].status = 1;
                    break;
                case "weibo":
                    this.statusList[3].status = 1;
                    break;
            }
        },
        errorResult(response) {
            this.options = {
                msgText: response.message,
                msgIsSuccess: false,
            };
        },
        /*
         ** 关闭弹窗
         */
        closePopup() {
            this.currentView = "";
            this.popup.isShow = false;
        },
        /*
         ** 根据传入的字段返回key
         */
        findType(name) {
            let index = this.socialMap[name];

            try {
                this.cacheSocialStatus.forEach((item, _index) => {
                    if (item.type == index) {
                        throw _index;
                    }
                });
            } catch (e) {
                return e;
            }
        },
        /*
         ** 绑定邮箱成功
         */
        bind_email_success(data) {
            this.statusList[0].value = data;
        },
        getIsSubscribed(value) {
            if (value) {
                this.$store.state.userInfo.wx_popup = !value
            }
        },
    },
    mounted() {
        axios.post(myUrl + "profile/user/social/").then((response) => {
            let res = response.data,
                    data = res.data;

            this.cacheSocialStatus = data;

            if (res.code == 0 && res.result) {
                // 邮箱
                let emailIndex = this.findType("email");
                this.statusList[0].status = data[emailIndex].status;
                this.statusList[0].value = data[emailIndex].value;
                // 手机
                let phoneIndex = this.findType("phone");
                this.statusList[1].status = data[phoneIndex].status;
                this.statusList[1].value = data[phoneIndex].value;
                // 微信
                let wechatIndex = this.findType("wechat");
                this.statusList[2].status = data[wechatIndex].status;
                this.statusList[2].value = data[wechatIndex].value;
                // 微博
                let weiboIndex = this.findType("weibo");
                this.statusList[3].status = data[weiboIndex].status;
                this.statusList[3].value = data[weiboIndex].value;
            } else {
                console.log(res.message);
            }
        });
        this.getStatus()
    },
    components: {
        popup,
        bind_email,
        modify_email,
        modify_phone,
        finish,
        bind_wechat,
        modify_third_party,
        "v-alert": vAlert,
    },
};
</script>

<style media="screen" lang="scss">
@import "./../../../scss/profile.scss";

select.monthselect {
    vertical-align: middle !important;
}
</style>
<style media="screen" lang="scss" scoped>
.s-popup-wrapper {
    min-height: 460px;
}

.bk-personal_center {
    .social {
        padding: 40px 50px 280px;

        .title-info {
            font-size: 12px;
            color: #a6a6a6;
        }

        .validate-list {
            margin-top: 38px;
            border-top: 1px solid #f4f4f4;

            .list-item {
                padding: 16px 0;
                height: 59px;
                border-bottom: 1px solid #f4f4f4;
                line-height: 26px;

                .col-left {
                    float: left;
                    font-size: 16px;
                    font-weight: bold;
                    width: 195px;
                    border-right: 1px solid #f4f4f4;
                    color: #666666;

                    .pre-icon {
                        display: inline-block;
                        margin-right: 12px;
                        margin-left: 23px;
                        font-size: 16px;
                    }

                    &.validate-ok {
                        color: #75ce3a;

                        .icon-mail {
                            background: url(../../../images/personal_center/icon-mail-ok.png) no-repeat;
                        }
                    }
                }

                .col-right {
                    float: left;
                    padding: 0 30px;
                    width: 616px;

                    .content {
                        float: left;
                        color: #a6a6a6;

                        .strong {
                            color: #666666;
                            font-weight: bold;
                        }
                    }

                    .operation {
                        float: right;

                        a {
                            color: #57a3f1;
                            /*i{
                                margin-left: 10px;
                                font-size: 16px;
                              }*/
                            .icon-play {
                                /* width: 14px;
                                  height: 14px;
                                  display: inline-block;
                                  background: url(../../../images/personal_center/icon-play.png) no-repeat; */
                                margin-left: 12px;
                                position: relative;
                                top: 2px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// social.vue?37d22421